import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useBoolean } from '@fluentui/react-hooks';
import PropTypes from 'prop-types';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { showMessage } from '../../../../../../common/Helpers';
import List from '../../../../../Templates/List';
import CLabel from '../../../../../Common/CLabel';
import moment from 'moment';
import { useGetListLastEvents } from '../../../../../../hooks/services/sKPI/useOfGAP';

const SidePanelViewRevisionEvents = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
    } = props;   

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetListLastEvents(inputParam_GapAnalyzeId, inputParam_GapRevisionId, messageEventList.pageNumber, messageEventList.pageSize, messageEventList, setMessageEventList, null, inputParam_IsPanelOpen);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
        setMessageEventList(__OBJECT_STRUCTURE_GetList())
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };
  

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-revisionevents') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                            <List
                                manipulateLocalData={ true }
                                listLocalStoragePageSizeVariableName="lastEventMessages"
                                className="no-compact-list"
                                data={ messageEventList.data !== null ? messageEventList : [] }
                                setData={ setMessageEventList }
                                columns={ messageEventList.data !== null ? [
                                {
                                    key: 'all-props-all-props',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'all-props-all-props',
                                    onRender:(item) => {
                                        const html = <Row>
                                                        <div className="text-end position-absolute">{ moment(item.gapEventDate).format("DD/MM/YYYY") }</div>
                                                        <Col xl={12}><CLabel labelText={t('data-lang-lbl-eventname')} labelValue={ item.gapEventName.indexOf('data-lang-skgapevent-type-') !== -1 ? t(item.gapEventName) : item.gapEventName} /></Col>
                                                        { item.gapEventDescription && <Col xl={12}><CLabel labelText={t('data-lang-lbl-description')} labelValue={item.gapEventDescription} /></Col> }
                                                        <Col xl={4}><CLabel labelText={t('data-lang-lbl-user')} labelValue={item.gapEventUsername} /></Col>
                                                        { item.gapEventStatusId !== null && <Col xl={4}><CLabel labelText={t('data-lang-lbl-status')} labelValue={item.gapEventStatusId} /></Col> }
                                                    </Row>
                        
                                        return  html;
                                    }
                                }
                            ] : []} />
                    </Col>
                </Row>

                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <MessageBox  
                            inputParam_Width="96%" 
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelViewRevisionEvents.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number.isRequired,
};

export default SidePanelViewRevisionEvents;